<div class="modal-header">
  <h3 class="modal-title">{{'start_guide_step1'| translate}}</h3>
  <img src="assets/svg/close-button.svg" alt="X" aria-label="Close" class="modal-close-btn" (click)="close()">
</div>
<div class="modal-body">
  <app-add-members></app-add-members>
</div>
